var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('h3',{staticClass:"text-center no-item-alert"},[_vm._v("موردی یافت نشد")])])}]

export { render, staticRenderFns }